// Redimensiona una imagen (logo del negocio, foto de mascota, etc.) en el
// navegador antes de guardarla, y la regresa como data URL base64 lista para
// mandar al backend y guardarse directamente en la base de datos (sin
// necesidad de un servicio externo de almacenamiento de archivos).
export function redimensionarImagenABase64(archivo: File, ladoMaximo = 600, calidad = 0.85): Promise<string> {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onerror = () => reject(new Error("No se pudo leer el archivo"));
    lector.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("No se pudo procesar la imagen"));
      img.onload = () => {
        let { width, height } = img;
        if (width > height && width > ladoMaximo) {
          height = Math.round((height * ladoMaximo) / width);
          width = ladoMaximo;
        } else if (height > ladoMaximo) {
          width = Math.round((width * ladoMaximo) / height);
          height = ladoMaximo;
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("No se pudo procesar la imagen"));
          return;
        }
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", calidad));
      };
      img.src = lector.result as string;
    };
    lector.readAsDataURL(archivo);
  });
}
